import {AfterViewInit, Component, ElementRef, EventEmitter, OnInit, Output} from '@angular/core';
import { JSProxyService } from '../../../../services/jsproxy.service';
import { ObjectFilterType } from '../../pipes/FilterObjects.pipe';

declare const $;

export class FilterData {
   public searchType: ObjectFilterType = ObjectFilterType.Name;
   public searchFilter: string = ""; 
}

@Component({
    selector: 'app-objects-filter',
    templateUrl: './objects-filter.component.html',
    styleUrls: ['./objects-filter.component.css'],
    standalone: false
})
export class ObjectsFilterComponent implements OnInit,AfterViewInit
{
  @Output() onSearch: EventEmitter<FilterData> = new EventEmitter();
  public Data: FilterData = new FilterData();

  private jsProxyService: JSProxyService;
  private rootElem: ElementRef
  public ObjectFilterType = ObjectFilterType;

  constructor(jsProxyService: JSProxyService, elRef: ElementRef) {
    this.jsProxyService = jsProxyService;
    this.rootElem = elRef;
  }

  ngOnInit() {
    this.Data.searchType = this.jsProxyService.getVar("DeviceList#SearchType", ObjectFilterType.Name);
    this.Data.searchFilter = this.jsProxyService.getVar("DeviceList#SearchInput", "");
  }

  ngAfterViewInit() {
    this.onFilterChange();
  }

  public onFilterChange()
  {
    this.onSearch.emit(this.Data);
    //input
    if (this.rootElem.nativeElement.childNodes[0].childNodes[0].oninput)
      this.rootElem.nativeElement.childNodes[0].childNodes[0].oninput();

    this.jsProxyService.setVar("DeviceList#SearchType", this.Data.searchType, false);
    this.jsProxyService.setVar("DeviceList#SearchInput", this.Data.searchFilter, false);
  }

  public selectFilter(objectFilterType: ObjectFilterType)
  {
    this.Data.searchType = objectFilterType;
    this.onFilterChange();
  }
}

